import type { Pipeline, PipelineStage, PipelineCommand } from '@/domain/model/Pipeline';
import type { PipelineGateway } from '@/application/port/out/PipelineGateway';
import type {
  ListPipelinesUseCase, ListPipelineStagesUseCase,
  CreatePipelineUseCase, UpdatePipelineUseCase, DeactivatePipelineUseCase,
} from '@/application/port/in/PipelineUseCase';

export class ListPipelines implements ListPipelinesUseCase {
  constructor(private readonly g: PipelineGateway) {}
  execute(): Promise<Pipeline[]> { return this.g.list(); }
}
export class ListPipelineStages implements ListPipelineStagesUseCase {
  constructor(private readonly g: PipelineGateway) {}
  execute(pipelineId: string): Promise<PipelineStage[]> { return this.g.listStages(pipelineId); }
}
export class CreatePipeline implements CreatePipelineUseCase {
  constructor(private readonly g: PipelineGateway) {}
  execute(cmd: PipelineCommand): Promise<Pipeline> { return this.g.create(cmd); }
}
export class UpdatePipeline implements UpdatePipelineUseCase {
  constructor(private readonly g: PipelineGateway) {}
  execute(id: string, cmd: PipelineCommand): Promise<Pipeline> { return this.g.update(id, cmd); }
}
export class DeactivatePipeline implements DeactivatePipelineUseCase {
  constructor(private readonly g: PipelineGateway) {}
  execute(id: string): Promise<void> { return this.g.deactivate(id); }
}
